"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_hash_link_1 = require("react-router-hash-link");
const Link = (0, react_1.forwardRef)(({ children, external = false, href, ...props }, ref) => {
    const useRouterLink = !external &&
        href.substring(0, 4) !== 'tel:' &&
        href.substring(0, 7) !== 'mailto:' &&
        !href.includes('://');
    return useRouterLink ? ((0, jsx_runtime_1.jsx)(react_router_hash_link_1.HashLink, { ref: ref, smooth: true, to: href, ...props, children: children })) : ((0, jsx_runtime_1.jsx)("a", { ref: ref, href: href, ...props, children: children }));
});
exports.default = Link;
